<tab-container>
    <ng-template tab-pane title="Human Health">
        <prediction-human-health ></prediction-human-health>
    </ng-template>
    <ng-template tab-pane title="Environmental">
        <prediction-environmental ></prediction-environmental>
    </ng-template>
</tab-container>
